export function decodeJWT(session) {
  if (!session?.access_token) return {};
  try {
    return JSON.parse(atob(session.access_token.split(".")[1]));
  } catch {
    return {};
  }
}

export const formatPhoneNumber = (value) => {
  if (!value.startsWith("+")) {
    const digits = value.replace(/\D/g, "").slice(0, 10);
    if (digits.length < 4) return digits;
    if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  const digits = value.replace(/\D/g, "");

  // Country codes are 1-3 digits; local numbers are always 10 digits
  const localLength = 10;
  const countryCodeLength = digits.length - localLength;

  if (countryCodeLength < 1 || countryCodeLength > 3) return value;

  const countryCode = "+" + digits.slice(0, countryCodeLength);
  const local = digits.slice(countryCodeLength);

  const formatted = `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
  return `${countryCode} ${formatted}`;
};

export const formatMonthYear = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    month: "short",
    year: "numeric",
  });
};

export function formatDateTime(dateTimeString, timezone = "America/New_York") {
  const date = new Date(dateTimeString.replace(" ", "T") + "Z");

  return new Intl.DateTimeFormat("en-US", {
    timeZone: timezone,
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(date);
}

export function formatTime(timeString) {
  if (!timeString) return "—";
  const [hours, minutes] = timeString.split(":").map(Number);
  const ampm = hours >= 12 ? "PM" : "AM";
  const h = hours % 12 || 12;
  return `${h}:${String(minutes).padStart(2, "0")} ${ampm}`;
}
